import api from "lib/api";

export const getBesmartConfig = async (params = {}) => {
  return await api.post("/v1/stpBeSmartConfig/getStpBeSmartConfig", params);
};
export const editBesmartConfig = async (params = {}) => {
  return await api.post("/v1/stpBeSmartConfig/editStpBeSmartConfig", params);
};
export const editStpBeSmartConfig = async (params = {}) => {
  return await api.post("/v1/stpBeSmartConfig/editStpBeSmartConfig", params);
};
